
export class CashBookSummary {
    CashBalance: number;
    TotalInvestment: number;
    TotalBooked: number;
    TotalCurrentValue: number;
    TotalProfit: number;
    TodaysProfit: number;
}
